module.exports = __webpack_public_path__ + "static/media/amrita_livelogo.2d6f71b1.png";